<div class="dashboard-content branding-screen" style="padding: 120px 40px 50px">
  <!-- Page Heading -->
  <div class="page-heading">
    <h3>
      <i class="fa-solid fa-palette" style="color: #5304fb;"></i>
      <span>{{ 'branding.title' | translate }}</span>
    </h3>
  </div>

  <!-- Custom Luqta Tabs & Actions -->
  <div class="custom-tabs-container mb-4">
    <div class="custom-tabs-header">
      <ul class="custom-nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link" role="tab" [class.active]="activeTab === 'brands'" (click)="onTabChange('brands')">
            {{ 'branding.brands-list' | translate }} ({{ brands.length }})
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" role="tab" [class.active]="activeTab === 'domains'" (click)="onTabChange('domains')">
            {{ 'branding.domains-hosts' | translate }} ({{ domains.length }})
          </a>
        </li>
      </ul>

      <div class="header-actions">
        <button class="btn action-btn-secondary" (click)="openExampleJsonModal()" [title]="'branding.example-json-title' | translate" type="button">
          <i class="fa-solid fa-file-code"></i>
          <span>{{ 'branding.example-json' | translate }}</span>
        </button>
        <button class="btn action-btn-secondary" (click)="openImportJsonModal()" [title]="'branding.import-json-title' | translate" type="button">
          <i class="fa-solid fa-file-import"></i>
          <span>{{ 'branding.import-json' | translate }}</span>
        </button>
        <button class="btn btn-primary action-btn-purple" (click)="openCreateDomainModal()" type="button">
          <i class="fa-solid fa-globe"></i>
          <span>{{ 'branding.add-domain' | translate }}</span>
        </button>
        <button class="btn btn-primary action-btn-purple" (click)="openCreateBrandModal()" type="button">
          <i class="fa-solid fa-plus"></i>
          <span>{{ 'branding.create-brand' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="luqta-card text-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- BRANDS TAB -->
  <div *ngIf="!isLoading && activeTab === 'brands'">
    <div *ngIf="brands.length === 0" class="luqta-card empty-state-card text-center py-5">
      <div class="empty-icon-circle mx-auto mb-3">
        <i class="fa-solid fa-palette"></i>
      </div>
      <h4 class="empty-title">{{ 'branding.no-brands' | translate }}</h4>
      <p class="empty-subtitle">
        {{ 'branding.no-brands-desc' | translate }}
      </p>
    </div>

    <div *ngIf="brands.length > 0" class="row g-4">
      <div *ngFor="let brand of brands" class="col-12 col-md-6 col-xl-4">
        <div class="luqta-card brand-card-box h-100 d-flex flex-column justify-content-between">
          <div>
            <div class="brand-card-header d-flex justify-content-between align-items-start mb-3 gap-2">
              <div class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
                <div class="brand-avatar-box" [style.backgroundColor]="getBrandAvatarLogo(brand) ? '#ffffff' : getBrandThemeColor(brand, 'primary')">
                  <img *ngIf="getBrandAvatarLogo(brand)" [src]="getBrandAvatarLogo(brand)" alt="Logo" class="brand-card-logo-img" />
                  <span *ngIf="!getBrandAvatarLogo(brand)">{{ (brand.name || brand.display_name || 'B').charAt(0).toUpperCase() }}</span>
                </div>
                <div class="min-w-0 flex-grow-1">
                  <h4 class="brand-title m-0">
                    {{ brand.name || brand.display_name || 'Brand Name' }}
                    <span *ngIf="brand.is_default" class="badge bg-amber-soft text-amber ms-1">{{ 'branding.default' | translate }}</span>
                  </h4>
                  <div *ngIf="brand.display_name && brand.display_name !== brand.name" class="font-12 fw-medium text-primary mt-0.5">
                    {{ brand.display_name }}
                    <span *ngIf="brand.brand?.identity?.display_name_ar" class="text-muted ms-1" dir="rtl">({{ brand.brand?.identity?.display_name_ar }})</span>
                  </div>
                  <div *ngIf="brand.brand?.identity?.tagline" class="text-muted font-11 mt-0.5">
                    <i class="fa-solid fa-quote-left text-xs me-1 text-muted opacity-50"></i>{{ brand.brand?.identity?.tagline }}
                  </div>
                  <small class="text-muted d-block mt-0.5">{{ brand.description || brand.brand?.meta?.description || ('branding.no-description' | translate) }}</small>
                </div>
              </div>
              <span class="status-badge" [class.active]="brand.is_active" [class.inactive]="!brand.is_active">
                {{ brand.is_default ? ('branding.default' | translate) : (brand.is_active ? ('branding.active' | translate) : ('branding.inactive' | translate)) }}
              </span>
            </div>

            <div class="swatches-section mb-3">
              <label class="section-label">{{ 'branding.theme-color-palette' | translate }}</label>
              <div class="d-flex align-items-center gap-2 mt-1 flex-wrap">
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'primary')"
                  nz-tooltip [nzTooltipTitle]="('branding.primary-color' | translate) + ': ' + getBrandThemeColor(brand, 'primary')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'secondary')"
                  nz-tooltip [nzTooltipTitle]="('branding.secondary-color' | translate) + ': ' + getBrandThemeColor(brand, 'secondary')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'accent')"
                  nz-tooltip [nzTooltipTitle]="('branding.accent-color' | translate) + ': ' + getBrandThemeColor(brand, 'accent')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'heading')"
                  nz-tooltip [nzTooltipTitle]="('branding.heading-color' | translate) + ': ' + getBrandThemeColor(brand, 'heading')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'bg')"
                  nz-tooltip [nzTooltipTitle]="('branding.bg-color' | translate) + ': ' + getBrandThemeColor(brand, 'bg')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'surface')"
                  nz-tooltip [nzTooltipTitle]="('branding.surface-color' | translate) + ': ' + getBrandThemeColor(brand, 'surface')"></div>
              </div>
            </div>

            <div class="domains-section mb-3">
              <label class="section-label">{{ 'branding.domains-hosts' | translate }}</label>
              <div class="d-flex flex-wrap gap-1 mt-1">
                <ng-container *ngFor="let dom of getBrandDomains(brand.id)">
                  <span class="domain-tag font-mono">{{ dom.hostname }}</span>
                </ng-container>
                <span *ngIf="!hasBrandDomains(brand.id)" class="text-muted fst-italic text-xs">{{ 'branding.no-domain-attached' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="brand-card-footer pt-3 border-top d-flex align-items-center justify-content-between flex-wrap gap-2">
            <button (click)="openEditBrandModal(brand)" class="btn btn-link p-0 edit-brand-btn d-inline-flex align-items-center gap-1" type="button">
              <i class="fa-solid fa-pen-to-square"></i> <span>{{ 'branding.edit' | translate }}</span>
            </button>
            <div class="brand-card-actions d-flex align-items-center gap-2 flex-wrap">
              <button *ngIf="!brand.is_default" (click)="setDefaultBrand(brand)" class="btn btn-light btn-sm font-12" type="button">
                <span>{{ 'branding.make-default' | translate }}</span>
              </button>
              <button (click)="openCreateDomainModal(brand.id)" class="btn btn-outline-primary btn-sm font-12 d-inline-flex align-items-center gap-1" type="button">
                <i class="fa-solid fa-plus"></i><span>{{ 'branding.add-domain' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DOMAINS TAB -->
  <div *ngIf="!isLoading && activeTab === 'domains'">
    <div class="luqta-card">
      <div class="card-heading mb-3">
        <div>
          <h3 class="m-0">{{ 'branding.domains-hosts' | translate }} ({{ domains.length }})</h3>
          <p class="card-subtitle">{{ 'branding.subtitle' | translate }}</p>
        </div>
      </div>

      <nz-table #domainsTable [nzData]="domains" [nzBordered]="true" [nzScroll]="{ x: '1000px' }">
        <thead>
          <tr>
            <th>{{ 'branding.domain-name' | translate }}</th>
            <th>{{ 'branding.brand' | translate }}</th>
            <th>{{ 'branding.type' | translate }}</th>
            <th>{{ 'branding.zero-storage' | translate }}</th>
            <th>{{ 'branding.status' | translate }}</th>
            <th class="text-end">{{ 'branding.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dom of domains">
            <td class="font-mono text-primary font-semibold">
              {{ dom.hostname }}
              <span *ngIf="dom.is_primary" class="badge bg-indigo-soft text-indigo ms-2">Primary</span>
            </td>
            <td class="font-medium">{{ getBrandName(dom) }}</td>
            <td class="text-capitalize text-muted text-xs">{{ dom.kind }}</td>
            <!--
              The hint identifies which key is on the host without being one —
              eight hex characters of a hash. The key itself is never returned
              by domain/list and is never shown here.
            -->
            <td>
              <ng-container *ngIf="dom.zero_storage; else standardStorage">
                <span class="badge bg-indigo-soft text-indigo">
                  <i class="fa-solid fa-lock me-1"></i>{{ 'branding.zero-storage-on' | translate }}
                </span>
                <div *ngIf="dom.zero_storage_key_hint" class="text-muted font-mono font-12 mt-1">
                  {{ 'branding.zero-storage-key-hint-label' | translate }}: {{ dom.zero_storage_key_hint }}
                </div>
              </ng-container>
              <ng-template #standardStorage>
                <span class="text-muted text-xs">{{ 'branding.zero-storage-off' | translate }}</span>
              </ng-template>
            </td>
            <td>
              <span class="status-badge" [class.active]="dom.status === 'live'"
                [class.expired]="dom.status === 'pending'">
                {{ dom.status === 'live' ? 'LIVE' : 'PENDING DNS' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2 flex-wrap table-actions">
                <button *ngIf="dom.dns_setup" (click)="showDnsSetup(dom)" class="btn btn-warning btn-sm font-12">
                  {{ 'branding.view-dns' | translate }}
                </button>
                <button *ngIf="dom.status === 'pending'" (click)="verifyDomain(dom)"
                  [disabled]="verifyingDomainId === dom.id" class="btn btn-info btn-sm font-12">
                  {{ verifyingDomainId === dom.id ? 'Checking...' : 'Verify DNS' }}
                </button>
                <button (click)="openEditDomainModal(dom)" class="btn btn-outline-primary btn-sm font-12" title="Edit Domain">
                  <i class="fa-solid fa-pen-to-square me-1"></i>{{ 'branding.edit' | translate }}
                </button>
                <button *ngIf="dom.status !== 'live'" (click)="deleteDomain(dom)"
                  class="btn btn-outline-danger btn-sm font-12">
                  {{ 'branding.delete' | translate }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>

<!-- BRAND MODAL (Create & Edit) -->
<nz-modal [(nzVisible)]="isBrandModalVisible" [nzCentered]="true"
  [nzTitle]="modalHeaderTpl"
  [nzFooter]="modalFooterTpl"
  (nzOnCancel)="isBrandModalVisible = false"
  [nzWidth]="880" nzClassName="luqta-styled-modal brand-customizer-modal">
  
  <ng-template #modalHeaderTpl>
    <div class="brand-modal-header-content">
      <div class="d-flex align-items-start">
        <div class="modal-header-icon-circle">
          <i class="fa-solid fa-palette"></i>
        </div>
        <div class="modal-header-text-block min-w-0 flex-grow-1">
          <h4 class="m-0 fw-bold text-dark font-18">{{ editingBrand ? ('branding.edit-brand-modal-title' | translate) : ('branding.create-brand-modal-title' | translate) }}</h4>
          <p class="text-muted font-12 m-0 mt-1">{{ 'branding.subtitle' | translate }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <form [formGroup]="brandForm" class="brand-customizer-form">

      <!-- JSON Quick Action Bar -->
      <div class="brand-json-quick-bar mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="json-bar-icon">
            <i class="fa-solid fa-code"></i>
          </div>
          <div>
            <div class="json-bar-title">JSON Configuration</div>
            <div class="json-bar-desc">Directly edit raw brand schema or import a JSON file.</div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn-json-action edit" (click)="openEditJsonFromForm()">
            <i class="fa-solid fa-code"></i>
            <span>{{ 'branding.edit-json' | translate }}</span>
          </button>
          <button type="button" class="btn-json-action upload" (click)="openUploadJsonFromForm()">
            <i class="fa-solid fa-cloud-arrow-up"></i>
            <span>{{ 'branding.upload-json' | translate }}</span>
          </button>
        </div>
      </div>
      
      <!-- Section 1: Basic Information -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">1</span>
          <span class="section-title">General Information</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-general' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.brand-name' | translate }} <span class="text-danger">*</span> <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-brand-name' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-with-icon">
              <i class="fa-solid fa-tag input-lead-icon"></i>
              <input formControlName="name" type="text" [placeholder]="'branding.brand-name-placeholder' | translate" class="form-control ps-5" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.description' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-description' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-with-icon">
              <i class="fa-solid fa-align-left input-lead-icon"></i>
              <input formControlName="description" type="text" [placeholder]="'branding.description-placeholder' | translate" class="form-control ps-5" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check">
              <input formControlName="is_active" type="checkbox" id="brand_is_active" class="form-check-input" />
              <label for="brand_is_active" class="form-check-label font-13 text-secondary">Active <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-is-active' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check">
              <input formControlName="is_default" type="checkbox" id="brand_is_default" class="form-check-input" />
              <label for="brand_is_default" class="form-check-label font-13 text-secondary">Use as default brand <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-is-default' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Colors & Real-Time Preview -->
      <div class="form-section-card mb-4">
        <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <div class="section-header m-0">
            <span class="section-step-badge">2</span>
            <span class="section-title">{{ 'branding.theme-color-palette' | translate }}</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-colors' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
          </div>
          <div class="theme-mode-toggle">
            <button type="button" (click)="colorThemeTab = 'light'" class="toggle-mode-btn" [class.active]="colorThemeTab === 'light'">
              <i class="fa-solid fa-sun me-1"></i> {{ 'branding.light-mode' | translate }}
            </button>
            <button type="button" (click)="colorThemeTab = 'dark'" class="toggle-mode-btn" [class.active]="colorThemeTab === 'dark'">
              <i class="fa-solid fa-moon me-1"></i> {{ 'branding.dark-mode' | translate }}
            </button>
          </div>
        </div>

        <div class="row g-4 align-items-center">
          <!-- Left: Color Swatch Inputs (2 Columns) -->
          <div class="col-12 col-md-7">
            <!-- Every colour in the brand schema, grouped. One block serves both themes:
                 the control name switches with the Light/Dark toggle. -->
            <div class="color-token-groups">
              <div *ngFor="let group of colorGroups" class="color-token-group">
                <div class="color-group-title">
                  <i [class]="group.icon"></i>
                  <span>{{ group.title }}</span>
                  <span nz-tooltip [nzTooltipTitle]="group.hint" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
                  <span class="color-group-count">{{ group.tokens.length }}</span>
                </div>

                <!--
                  formControlName binds once when the directive initialises and
                  never re-reads its expression, so switching the Light/Dark tab
                  alone leaves these inputs attached to the previous mode's
                  controls. Keying the grid on the active tab tears the inputs
                  down and rebuilds them against the correct control names.
                -->
                <div class="color-swatches-grid" [ngSwitch]="colorThemeTab">
                  <ng-container *ngSwitchCase="'light'" [ngTemplateOutlet]="swatchGrid"
                                [ngTemplateOutletContext]="{ $implicit: group }"></ng-container>
                  <ng-container *ngSwitchCase="'dark'" [ngTemplateOutlet]="swatchGrid"
                                [ngTemplateOutletContext]="{ $implicit: group }"></ng-container>
                </div>

                <ng-template #swatchGrid let-group>
                  <div *ngFor="let t of group.tokens" class="color-swatch-box">
                    <label class="color-label" nz-tooltip [nzTooltipTitle]="t.hint">
                      {{ t.label }}
                      <span *ngIf="t.required" class="text-danger">*</span>
                    </label>
                    <div class="color-input-wrapper">
                      <input [formControlName]="colorControl(t.token)" type="color" class="color-picker-native" />
                      <input
                        [formControlName]="colorControl(t.token)"
                        (input)="onColorHexInput(colorControl(t.token), $event)"
                        (blur)="onColorHexBlur(colorControl(t.token))"
                        type="text"
                        class="color-hex-input"
                        maxlength="7"
                      />
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- Right: Real-Time Mobile Preview -->
          <div class="col-12 col-md-5">
            <div class="clean-preview-wrapper">
              <div class="text-uppercase text-muted font-11 fw-bold text-center mb-2">
                <i class="fa-solid fa-mobile-screen me-1 text-primary"></i> {{ 'branding.real-time-preview' | translate }}
              </div>

              <!-- Mock phone device -->
              <div class="preview-phone mx-auto" [class.is-dark]="colorThemeTab === 'dark'">
                <div class="preview-phone-notch"></div>

                <div class="preview-phone-screen"
                  [attr.dir]="previewDir"
                  [style.fontFamily]="previewFontFamily"
                  [style.fontSize.px]="previewFontSize"
                  [style.backgroundColor]="pv('bg_color', 'dark_bg_color', '#F7F6F9', '#0D1620')">

                  <!-- Status bar -->
                  <div class="preview-status-bar" [style.color]="pv('text_color', 'dark_text_color', '#122331', '#FFFFFF')">
                    <span class="preview-status-time">9:41</span>
                    <span class="preview-status-icons">
                      <i class="fa-solid fa-signal"></i>
                      <i class="fa-solid fa-wifi"></i>
                      <i class="fa-solid fa-battery-three-quarters"></i>
                    </span>
                  </div>

                  <!-- In-app browser bar: favicon + SEO page title -->
                  <div class="preview-url-bar"
                    [style.backgroundColor]="pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331')"
                    [style.color]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')">
                    <img *ngIf="brandForm.value.icon_url" [src]="extractUrl(brandForm.value.icon_url)" alt="Favicon" class="preview-favicon" />
                    <i *ngIf="!brandForm.value.icon_url" class="fa-solid fa-globe preview-favicon-fallback"></i>
                    <span class="preview-tab-title" [title]="previewTitle">{{ previewTitle }}</span>
                    <i class="fa-solid fa-rotate-right preview-url-reload"></i>
                  </div>

                  <!-- Scrollable page body, constrained by shell_max -->
                  <div class="preview-phone-body">
                    <div class="preview-shell mx-auto" [style.maxWidth.px]="previewShellWidth">

                      <div class="preview-inner-card p-3 border mb-2"
                        [style.backgroundColor]="pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331')"
                        [style.borderRadius.px]="brandForm.value.radius || 12">

                        <!-- Logo / avatar + name + tagline -->
                        <div class="d-flex align-items-center gap-2 mb-2">
                          <img *ngIf="previewLogoUrl" [src]="previewLogoUrl" alt="Logo" class="preview-logo-img" />
                          <div *ngIf="!previewLogoUrl" class="preview-avatar-placeholder"
                            [style.backgroundColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"
                            [style.borderRadius.px]="brandForm.value.radius || 12">
                            {{ previewName.charAt(0).toUpperCase() }}
                          </div>
                          <div class="overflow-hidden flex-grow-1">
                            <h5 class="fw-bold mb-0 lh-sm text-truncate preview-heading"
                              [style.color]="pv('heading_color', 'dark_heading_color', '#122331', '#FFFFFF')">
                              {{ previewName }}
                            </h5>
                            <span class="d-block text-truncate preview-sub"
                              [style.color]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')">
                              {{ previewTagline }}
                            </span>
                          </div>
                        </div>

                        <p class="mb-2 preview-body"
                          [style.color]="pv('text_color', 'dark_text_color', '#122331', '#CBD5E1')">
                          Complete the tasks below to enter the draw.
                        </p>

                        <!-- Status pills: success / warning / error -->
                        <div class="d-flex flex-wrap gap-1 mb-2">
                          <span class="preview-pill" [style.borderRadius.px]="brandForm.value.button_radius || 12"
                            [style.backgroundColor]="pv('success_color', 'dark_success_color', '#1F9254', '#34D399')">
                            <i class="fa-solid fa-check me-1"></i>Completed
                          </span>
                          <span class="preview-pill" [style.borderRadius.px]="brandForm.value.button_radius || 12"
                            [style.backgroundColor]="pv('warning_color', 'dark_warning_color', '#D97706', '#F59E0B')">
                            <i class="fa-solid fa-clock me-1"></i>Pending
                          </span>
                          <span class="preview-pill" [style.borderRadius.px]="brandForm.value.button_radius || 12"
                            [style.backgroundColor]="pv('error_color', 'dark_error_color', '#EF233C', '#FF5A6E')">
                            <i class="fa-solid fa-xmark me-1"></i>Failed
                          </span>
                        </div>

                        <button type="button" class="btn w-100 text-white fw-semibold py-2 transition-all preview-btn"
                          [style.backgroundColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"
                          [style.borderRadius.px]="brandForm.value.button_radius || 12">
                          {{ 'branding.enter-contest' | translate }}
                        </button>

                        <button type="button" class="btn w-100 fw-semibold py-2 transition-all mt-1 preview-btn preview-btn-outline"
                          [style.borderColor]="pv('secondary_color', 'dark_secondary_color', '#122331', '#FFD451')"
                          [style.color]="pv('secondary_color', 'dark_secondary_color', '#122331', '#FFD451')"
                          [style.borderRadius.px]="brandForm.value.button_radius || 12">
                          View my prizes
                        </button>

                        <div class="text-center mt-2">
                          <span class="preview-link" [style.color]="pv('accent_color', 'dark_accent_color', '#FCBA03', '#FCBA03')">
                            How it works?
                          </span>
                        </div>
                      </div>

                      <!-- Support / social / legal footer -->
                      <div class="preview-footer text-center"
                        [style.color]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')">

                        <div *ngIf="previewSocials.length" class="d-flex justify-content-center gap-2 mb-1">
                          <i *ngFor="let s of previewSocials" [class]="s.icon" class="preview-social-icon"
                            [style.color]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"></i>
                        </div>

                        <div *ngIf="brandForm.value.support_email || brandForm.value.support_phone || brandForm.value.support_whatsapp"
                          class="preview-footer-line text-truncate">
                          <span *ngIf="brandForm.value.support_email"><i class="fa-solid fa-envelope me-1"></i>{{ brandForm.value.support_email }}</span>
                          <span *ngIf="brandForm.value.support_phone" class="ms-2"><i class="fa-solid fa-phone me-1"></i>{{ brandForm.value.support_phone }}</span>
                          <span *ngIf="brandForm.value.support_whatsapp" class="ms-2"><i class="fa-brands fa-whatsapp me-1"></i>{{ brandForm.value.support_whatsapp }}</span>
                        </div>

                        <div *ngIf="brandForm.value.terms_url || brandForm.value.privacy_url" class="preview-footer-line">
                          <span *ngIf="brandForm.value.terms_url">Terms</span>
                          <span *ngIf="brandForm.value.terms_url && brandForm.value.privacy_url" class="mx-1">·</span>
                          <span *ngIf="brandForm.value.privacy_url">Privacy</span>
                        </div>

                        <div *ngIf="brandForm.value.powered_by" class="preview-footer-line">
                          {{ 'branding.powered-by' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preview-home-indicator"
                    [style.backgroundColor]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')"></div>
                </div>
              </div>

              <div class="text-center text-muted font-10 mt-2">
                {{ brandForm.value.shell_max || 400 }}px shell · {{ brandForm.value.base_size || 16 }}px base ·
                {{ previewIsArabic ? (brandForm.value.font_family_ar || 'Vazirmatn') : (brandForm.value.font_family || 'Inter') }}
                · {{ previewIsArabic ? 'RTL' : 'LTR' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Typography & Shape -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">3</span>
          <span class="section-title">Typography & Shape</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-typography' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.font-source' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-font-source' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <nz-select formControlName="font_source" class="w-100 custom-nz-select">
              <nz-option nzValue="google" [nzLabel]="'branding.google-font' | translate"></nz-option>
              <nz-option nzValue="system" [nzLabel]="'branding.system-default' | translate"></nz-option>
            </nz-select>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.font-family' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-font-family' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="font_family" type="text" placeholder="Inter" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Arabic Font Family <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-font-family-ar' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="font_family_ar" type="text" placeholder="Vazirmatn" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Base Font Size <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-base-font-size' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-group">
              <input formControlName="base_size" type="number" min="12" max="24" class="form-control" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.card-radius' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-card-radius' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-group">
              <input formControlName="radius" type="number" min="0" max="40" class="form-control" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Button Radius <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-button-radius' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-group">
              <input formControlName="button_radius" type="number" min="0" max="40" class="form-control" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Content Max Width <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-content-max-width' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <div class="input-group">
              <input formControlName="shell_max" type="number" min="320" max="1200" class="form-control" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 4: Display Names -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">4</span>
          <span class="section-title">Localized Identity</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-localized' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.display-name-en' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-display-name-en' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="display_name" type="text" placeholder="Spica Retail" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.display-name-ar' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-display-name-ar' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="display_name_ar" type="text" placeholder="سبيكا" dir="rtl" class="form-control text-end" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Tagline (EN) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-tagline-en' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="tagline" type="text" placeholder="Scan, Play, Win" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Tagline (AR) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-tagline-ar' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="tagline_ar" type="text" placeholder="امسح، العب، واربح" dir="rtl" class="form-control text-end" />
          </div>
        </div>
      </div>

      <!-- Section 5: SEO & Page Meta -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">5</span>
          <span class="section-title">SEO & Page Meta</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-seo' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Page Title (EN) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-page-title-en' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="title" type="text" placeholder="Join the campaign | Brand" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Page Title (AR) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-page-title-ar' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="title_ar" type="text" placeholder="انضم إلى الحملة" dir="rtl" class="form-control text-end" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Meta Description (EN) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-meta-description-en' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <textarea formControlName="meta_description" rows="2" placeholder="Short description shown in search results and link previews" class="form-control"></textarea>
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Meta Description (AR) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-meta-description-ar' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <textarea formControlName="meta_description_ar" rows="2" dir="rtl" class="form-control text-end"></textarea>
          </div>
        </div>
      </div>

      <!-- Section 6: Support & Contact -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">6</span>
          <span class="section-title">Support & Contact</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-support' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Support Email <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-support-email' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="support_email" type="email" placeholder="support@brand.com" class="form-control" />
            <div class="text-danger font-12 mt-1" *ngIf="brandForm.controls['support_email'].invalid && brandForm.controls['support_email'].touched">
              Please enter a valid email address.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Support Phone <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-support-phone' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="support_phone" type="text" placeholder="+249 000 000 000" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">WhatsApp <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-whatsapp' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="support_whatsapp" type="text" placeholder="+249 000 000 000" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Website <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-website' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="support_website" type="url" placeholder="https://brand.com" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Section 7: Social Links -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">7</span>
          <span class="section-title">Social Links</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-social' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-x-twitter me-1"></i> X (Twitter) <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-x' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_x" type="url" placeholder="https://twitter.com/brand" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-instagram me-1"></i> Instagram <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-instagram' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_instagram" type="url" placeholder="https://instagram.com/brand" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-youtube me-1"></i> YouTube <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-youtube' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_youtube" type="url" placeholder="https://youtube.com/@brand" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-tiktok me-1"></i> TikTok <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-tiktok' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_tiktok" type="url" placeholder="https://tiktok.com/@brand" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-snapchat me-1"></i> Snapchat <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-snapchat' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_snapchat" type="url" placeholder="https://snapchat.com/add/brand" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-linkedin me-1"></i> LinkedIn <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-social-linkedin' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="social_linkedin" type="url" placeholder="https://linkedin.com/company/brand" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Section 8: Legal & Defaults -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">8</span>
          <span class="section-title">Legal & Defaults</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-legal' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Terms & Conditions URL <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-terms-url' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="terms_url" type="url" placeholder="https://brand.com/terms" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Privacy Policy URL <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-privacy-url' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <input formControlName="privacy_url" type="url" placeholder="https://brand.com/privacy" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Default Theme <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-default-theme' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <nz-select formControlName="default_theme" class="w-100 custom-nz-select">
              <nz-option nzValue="system" nzLabel="Follow device"></nz-option>
              <nz-option nzValue="light" nzLabel="Light"></nz-option>
              <nz-option nzValue="dark" nzLabel="Dark"></nz-option>
            </nz-select>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Default Language <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-default-language' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
            <nz-select formControlName="default_language" class="w-100 custom-nz-select">
              <nz-option nzValue="en" nzLabel="English"></nz-option>
              <nz-option nzValue="ar" nzLabel="العربية"></nz-option>
            </nz-select>
          </div>
          <div class="col-md-6 d-flex align-items-end">
            <div class="form-check">
              <input formControlName="powered_by" type="checkbox" id="powered_by" class="form-check-input" />
              <label for="powered_by" class="form-check-label font-13 text-secondary">
                Show "Powered by" badge on the participant page
                <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-powered-by' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 9: Brand Assets & Logos -->
      <div class="form-section-card mb-2">
        <div class="section-header mb-3">
          <span class="section-step-badge">9</span>
          <span class="section-title">Brand Logos & Icons</span>
          <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-section-assets' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span>
        </div>
        <div class="row g-3">
          <!-- Logo Light -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.logo-url-light' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-logo-url-light' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
              <input type="file" #logoFileInput accept="image/*" (change)="onFileSelected($event, 'logo_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.logo_url; else logoLightUploadBox">
                <div class="asset-preview-box">
                  <img [src]="extractUrl(brandForm.value.logo_url)" alt="Logo Light" class="asset-img" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('logo_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('logo_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #logoLightUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('logo_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Logo (Light)</div>
                  <div class="dropzone-subtitle">Click to browse image</div>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Logo Dark -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.logo-url-dark' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-logo-url-dark' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
              <input type="file" #logoDarkFileInput accept="image/*" (change)="onFileSelected($event, 'logo_dark_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.logo_dark_url; else logoDarkUploadBox">
                <div class="asset-preview-box is-dark">
                  <img [src]="extractUrl(brandForm.value.logo_dark_url)" alt="Logo Dark" class="asset-img" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('logo_dark_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('logo_dark_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #logoDarkUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('logo_dark_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Logo (Dark)</div>
                  <div class="dropzone-subtitle">Click to browse image</div>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Favicon Icon -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.favicon-url' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-favicon-url' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
              <input type="file" #iconFileInput accept="image/*" (change)="onFileSelected($event, 'icon_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.icon_url; else iconUploadBox">
                <div class="asset-preview-box">
                  <img [src]="extractUrl(brandForm.value.icon_url)" alt="Favicon" class="asset-img is-icon" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('icon_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('icon_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #iconUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('icon_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Favicon</div>
                  <div class="dropzone-subtitle">Square icon (PNG/ICO)</div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

    </form>
  </ng-container>

  <ng-template #modalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2 w-100">
      <button type="button" class="btn-modal-cancel" (click)="isBrandModalVisible = false">
        {{ 'branding.cancel' | translate }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="isSavingBrand" (click)="saveBrand()">
        <span *ngIf="isSavingBrand" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingBrand" class="fa-solid fa-check me-2"></i>
        {{ editingBrand ? ('branding.update' | translate) : ('branding.ok' | translate) }}
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- DOMAIN MODAL (Add / Edit Domain) -->
<nz-modal [(nzVisible)]="isDomainModalVisible" [nzCentered]="true"
  [nzTitle]="(editingDomain ? 'branding.edit-domain-modal-title' : 'branding.add-domain-modal-title') | translate"
  [nzOkText]="(editingDomain ? 'branding.update' : 'branding.ok') | translate"
  [nzCancelText]="'branding.cancel' | translate" (nzOnCancel)="closeDomainModal()" (nzOnOk)="saveDomain()"
  [nzOkLoading]="isSavingDomain" nzClassName="luqta-styled-modal">
  <ng-container *nzModalContent>
    <form [formGroup]="domainForm" class="space-y-3 text-sm">
      <div class="mb-3">
        <label class="form-label font-medium">{{ 'branding.domain-name' | translate }} * <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-domain-name' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
        <input formControlName="hostname" type="text" [placeholder]="'branding.domain-placeholder' | translate"
          class="form-control font-mono" />
        <small *ngIf="!editingDomain" class="text-muted mt-1 d-block font-12">
          {{ 'branding.domain-hint-1' | translate }} <code>.luqta.io</code> or <code>.luqta.app</code> {{
          'branding.domain-hint-2' | translate }}
        </small>
        <small *ngIf="editingDomain" class="text-muted mt-1 d-block font-12">
          {{ 'branding.domain-hostname-locked' | translate }}
        </small>
      </div>

      <div class="mb-3">
        <label class="form-label font-medium d-block mb-1">{{ 'branding.attach-to-brand' | translate }} * <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-attach-to-brand' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
        <nz-select formControlName="branding_id" [nzPlaceHolder]="'branding.select-brand-placeholder' | translate"
          nzShowSearch class="w-100">
          <nz-option *ngFor="let b of brands" [nzValue]="b.id" [nzLabel]="b.name + ' (ID: ' + b.id + ')'"></nz-option>
        </nz-select>
      </div>

      <div class="form-check">
        <input formControlName="is_primary" type="checkbox" id="is_primary" class="form-check-input" />
        <label for="is_primary" class="form-check-label font-12">{{ 'branding.set-primary-domain' | translate }} <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-set-primary-domain' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
      </div>

      <!--
        ZERO STORAGE — create only.
        The three warnings below are permanent consequences of this switch, so
        they are body copy in the form rather than a tooltip. An existing domain
        gets the read-only summary underneath instead: the mode and the key can
        never be changed once the row exists.
      -->
      <div class="zero-storage-block mt-4 p-3 bg-light rounded border">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label font-medium m-0 d-flex align-items-center gap-2">
            <i class="fa-solid fa-lock text-secondary"></i>
            {{ 'branding.zero-storage' | translate }}
          </label>
          <div *ngIf="!editingDomain" class="form-check form-switch m-0">
            <input formControlName="zero_storage" type="checkbox" id="zero_storage" class="form-check-input" />
          </div>
          <span *ngIf="editingDomain" class="badge"
            [class.bg-indigo-soft]="editingDomain.zero_storage"
            [class.text-indigo]="editingDomain.zero_storage"
            [class.bg-light]="!editingDomain.zero_storage"
            [class.text-muted]="!editingDomain.zero_storage">
            {{ (editingDomain.zero_storage ? 'branding.zero-storage-on' : 'branding.zero-storage-off') | translate }}
          </span>
        </div>

        <p class="text-muted font-12 mb-3">{{ 'branding.zero-storage-desc' | translate }}</p>

        <!-- Read-only for an existing domain: neither field can be sent to domain/update. -->
        <ng-container *ngIf="editingDomain">
          <div *ngIf="editingDomain.zero_storage && editingDomain.zero_storage_key_hint" class="font-12 mb-2">
            <span class="text-muted">{{ 'branding.zero-storage-key-hint-label' | translate }}:</span>
            <code class="font-mono ms-1">{{ editingDomain.zero_storage_key_hint }}</code>
          </div>
          <div class="alert alert-warning font-12 m-0">
            {{ 'branding.zero-storage-read-only' | translate }}
          </div>
        </ng-container>

        <ng-container *ngIf="!editingDomain">
          <div *ngIf="domainForm.controls['zero_storage'].value" class="mb-3">
            <label class="form-label font-medium font-12">{{ 'branding.zero-storage-key' | translate }} *</label>
            <input formControlName="zero_storage_key" type="password" autocomplete="new-password"
              [placeholder]="'branding.zero-storage-key-placeholder' | translate" class="form-control font-mono" />
            <div class="text-danger font-12 mt-1"
              *ngIf="domainForm.controls['zero_storage_key'].invalid && domainForm.controls['zero_storage_key'].touched">
              {{ 'branding.zero-storage-key-required' | translate }}
            </div>
          </div>

          <div class="alert alert-warning font-12 m-0">
            <div class="font-semibold mb-2">{{ 'branding.zero-storage-warning-title' | translate }}</div>
            <ul class="m-0 ps-3">
              <li class="mb-2">{{ 'branding.zero-storage-warning-permanent' | translate }}</li>
              <li class="mb-2">{{ 'branding.zero-storage-warning-unrecoverable' | translate }}</li>
              <li>{{ 'branding.zero-storage-warning-create-only' | translate }}</li>
            </ul>
          </div>
        </ng-container>
      </div>
    </form>
  </ng-container>
</nz-modal>

<!-- DNS SETUP MODAL -->
<nz-modal [(nzVisible)]="dnsModalVisible" [nzCentered]="true"
  [nzTitle]="'DNS Instructions for ' + selectedDnsSetup?.hostname" (nzOnCancel)="dnsModalVisible = false"
  [nzFooter]="null" nzClassName="luqta-styled-modal">
  <ng-container *nzModalContent>
    <div class="space-y-3 text-sm">
      <p class="text-muted">
        Add the following two DNS records at your domain registrar (GoDaddy, Cloudflare, Namecheap, etc.) to complete
        verification:
      </p>

      <div *ngIf="selectedDnsSetup?.dns?.cname" class="p-3 bg-light rounded border">
        <label class="font-bold text-muted uppercase d-block mb-1 font-12">CNAME Record <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-cname-record' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
        <div class="row font-mono font-12">
          <div class="col-6"><span class="text-muted">Host:</span> {{ selectedDnsSetup.dns.cname.name }}</div>
          <div class="col-6"><span class="text-muted">Target:</span> {{ selectedDnsSetup.dns.cname.value }}</div>
        </div>
      </div>

      <div *ngIf="selectedDnsSetup?.dns?.txt" class="p-3 bg-light rounded border">
        <label class="font-bold text-muted uppercase d-block mb-1 font-12">TXT Verification Record <span nz-tooltip nzTooltipTitle="{{ 'branding.tooltip-txt-record' | translate }}" nzTooltipPlacement="top"><i class="fa-solid fa-circle-info info"></i></span></label>
        <div class="font-mono font-12">
          <div><span class="text-muted">Name:</span> {{ selectedDnsSetup.dns.txt.name }}</div>
          <div class="d-flex justify-content-between align-items-center mt-1">
            <div><span class="text-muted">Value:</span> {{ selectedDnsSetup.dns.txt.value }}</div>
            <button (click)="copyToClipboard(selectedDnsSetup.dns.txt.value)"
              class="btn btn-link btn-sm p-0">Copy</button>
          </div>
        </div>
      </div>

      <div class="alert alert-warning font-12 m-0 mt-3">
        After setting DNS records, press "Verify DNS" in the domains list. DNS propagation can take up to 1 hour.
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- EDIT JSON MODAL -->
<nz-modal [(nzVisible)]="isJsonModalVisible" [nzCentered]="true" [nzWidth]="780"
  [nzTitle]="jsonModalTitleTpl" [nzFooter]="jsonModalFooterTpl"
  (nzOnCancel)="closeEditJsonModal()" nzClassName="luqta-styled-modal">
  <ng-template #jsonModalTitleTpl>
    <div class="d-flex align-items-center gap-2">
      <i class="fa-solid fa-code text-primary"></i>
      <span *ngIf="!isExampleJsonModal">{{ 'branding.edit-json-modal-title' | translate }}</span>
      <span *ngIf="isExampleJsonModal">{{ 'branding.example-brand-schema' | translate }}</span>
      <span *ngIf="jsonModalBrand && !isExampleJsonModal" class="badge bg-purple-soft text-purple ms-2 font-12">
        {{ jsonModalBrand.name }}
      </span>
      <span *ngIf="isExampleJsonModal" class="badge bg-purple-soft text-purple ms-2 font-12">
        {{ 'branding.sample-template' | translate }}
      </span>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div class="json-modal-body">
      <!-- Hidden file input for uploading directly into editor -->
      <input #editJsonFileInput type="file" accept=".json,application/json" class="d-none" (change)="onEditJsonFileSelected($event)" />

      <div class="json-editor-container mb-3">
        <div class="json-editor-toolbar">
          <span class="json-editor-title">
            <i class="fa-regular fa-file-code me-1"></i> config.json
          </span>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <button type="button" class="btn-toolbar-action" (click)="triggerEditJsonFileInput()" title="Import JSON file into editor">
              <i class="fa-solid fa-upload"></i> {{ 'branding.upload-json' | translate }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="prettifyJson()" title="Format JSON">
              <i class="fa-solid fa-wand-magic-sparkles"></i> {{ 'branding.prettify-json' | translate }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="copyJsonToClipboard()" title="Copy JSON">
              <i class="fa-regular fa-copy"></i> {{ isCopied ? ('branding.copied' | translate) : ('branding.copy-json' | translate) }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="downloadJson()" title="Download JSON file">
              <i class="fa-solid fa-download"></i> {{ 'branding.download-json' | translate }}
            </button>
          </div>
        </div>
        <textarea [(ngModel)]="rawJsonString" class="json-textarea" spellcheck="false"
          [placeholder]="'branding.json-placeholder' | translate"></textarea>
      </div>

      <div *ngIf="jsonError" class="alert alert-danger font-12 d-flex align-items-center gap-2 mb-0 py-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ jsonError }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #jsonModalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2 flex-wrap">
      <button type="button" class="btn-modal-cancel" (click)="closeEditJsonModal()">
        {{ isExampleJsonModal ? ('branding.close' | translate) : ('branding.cancel' | translate) }}
      </button>
      <button *ngIf="isExampleJsonModal" type="button" class="btn-modal-secondary" (click)="copyJsonToClipboard()">
        <i class="fa-regular fa-copy me-2"></i>
        {{ isCopied ? ('branding.copied' | translate) : ('branding.copy-example' | translate) }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="isSavingJson" (click)="saveBrandJson()">
        <span *ngIf="isSavingJson" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingJson" class="fa-solid fa-check me-2"></i>
        {{ isExampleJsonModal ? ('branding.create-from-template' | translate) : ('branding.save-json' | translate) }}
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- UPLOAD JSON MODAL -->
<nz-modal [(nzVisible)]="isUploadJsonModalVisible" [nzCentered]="true" [nzWidth]="640"
  [nzTitle]="uploadJsonModalTitleTpl" [nzFooter]="uploadJsonModalFooterTpl"
  (nzOnCancel)="closeUploadJsonModal()" nzClassName="luqta-styled-modal">
  <ng-template #uploadJsonModalTitleTpl>
    <div class="d-flex align-items-center gap-2">
      <i class="fa-solid fa-cloud-arrow-up text-primary"></i>
      <span>{{ 'branding.upload-json-modal-title' | translate }}</span>
      <span *ngIf="uploadJsonBrand" class="badge bg-purple-soft text-purple ms-2 font-12">
        {{ uploadJsonBrand.name }}
      </span>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div class="upload-json-body space-y-3">
      <input #jsonFileInput type="file" accept=".json,application/json" class="d-none" (change)="onJsonFileSelected($event)" />

      <!-- Drag and drop zone -->
      <div *ngIf="!uploadedJsonFileName" class="json-dropzone-box" [class.dragover]="isDragging"
        (click)="triggerJsonFileInput()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDropJsonFile($event)">
        <div class="dropzone-icon">
          <i class="fa-solid fa-cloud-arrow-up"></i>
        </div>
        <h5 class="dropzone-title">{{ 'branding.json-upload-dropzone' | translate }}</h5>
        <p class="dropzone-desc mb-0">{{ 'branding.json-upload-hint' | translate }}</p>
      </div>

      <!-- Uploaded file summary card -->
      <div *ngIf="uploadedJsonFileName" class="uploaded-file-card mb-3">
        <div class="file-meta">
          <i class="fa-solid fa-file-circle-check"></i>
          <div>
            <div class="file-name">{{ uploadedJsonFileName }}</div>
            <div class="file-status text-success font-12">{{ 'branding.valid-json-success' | translate }}</div>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-link text-danger p-0" (click)="clearUploadedJsonFile()" title="Remove file">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>

      <!-- Preview code box if file loaded -->
      <div *ngIf="uploadedJsonData" class="json-editor-container mb-3">
        <div class="json-editor-toolbar">
          <span class="json-editor-title">
            <i class="fa-solid fa-eye me-1"></i> {{ 'branding.preview' | translate }}: {{ uploadedJsonFileName }}
          </span>
        </div>
        <textarea [value]="uploadedJsonData | json" class="json-textarea" style="height: 180px;" readonly></textarea>
      </div>

      <!-- Error message -->
      <div *ngIf="uploadJsonError" class="alert alert-danger font-12 d-flex align-items-center gap-2 mb-0 py-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ uploadJsonError }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #uploadJsonModalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2">
      <button type="button" class="btn-modal-cancel" (click)="closeUploadJsonModal()">
        {{ 'branding.cancel' | translate }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="!uploadedJsonData || isSavingUploadJson" (click)="saveUploadedJson()">
        <span *ngIf="isSavingUploadJson" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingUploadJson" class="fa-solid fa-check me-2"></i>
        {{ 'branding.apply-json' | translate }}
      </button>
    </div>
  </ng-template>
</nz-modal>